import { PureComponent } from 'react';
import Promotion from 'Component/Promotion';
import PromotionList from 'Component/PromotionList';

class PromotionPage extends PureComponent {
    render() {
        const { location } = this.props;
        const url = location.pathname.split('/')[location.pathname.split('/').length - 1];

        return (
            url === 'promo' ? <PromotionList /> : <Promotion slug={ url } />
        );
    }
}

export default PromotionPage;
